import {Col, Row, Image} from 'antd';
import React, {useEffect, useState,useRef} from 'react';
import './index.css'
import {useSelector, useDispatch} from 'react-redux';
import {hyperChat, getHistoryMessages} from '../../../api/other'
import DictionaryAnswer from "./dictionaryAnswer";
import DictionaryQuestion from "./dictionaryQuestion";
import CreateChatApp from "../../../comm/createChat";


const App = (props) => {
    const {sendTxt, setSendTxt,clearContent,setClearContent,setHomePageIndex,homePageIndex,themeVlue} = props
    const {size} = useSelector(state => state.fontSizeChange)
    const {userInfo, allContextMeta} = useSelector(state => state.user)
    // const {avatar} = userInfo
    var dictionary_meta = null
	if(allContextMeta){
		dictionary_meta = allContextMeta.dictionary_meta
	}
    const dispatch = useDispatch()
    const noAnswer = {
        fontSize: size === '小' ? '15px' : (size === '中' ? '18px' : '22px'),
        margin: size === '小' ? '10px 0' : (size === '中' ? '8px 0' : '6px 0')
    }
    const sizeStyle = {
        fontSize: size === '小' ? '15px' : (size === '中' ? '18px' : '22px')
    }
    const sizeSmall = {
        fontSize: size === '小' ? '13px' : (size === '中' ? '15px' : '18px')
    }
    const itemL = {
        fontSize: size === '小' ? '16px' : (size === '中' ? '19px' : '23px')
    }
    const answerThree = {
        fontSize: size === '小' ? '12px' : (size === '中' ? '14px' : '16px')
    }
    const answerTwo = {
        fontSize: size === '小' ? '18px' : (size === '中' ? '21px' : '25px')
    }
    const answerOne = {
        fontSize: size === '小' ? '28px' : (size === '中' ? '30px' : '32px')
    }
    // 会话集合
    const [pageList, setPageList] = useState([])
	const [viewType,setViewType] = useState('instant')
    useEffect(() => {
        if (sendTxt) {
            let list = pageList
            list.push({
                user_content:sendTxt.user_content
            })
			setViewType('smooth')
            setPageList([...list])
			setTimeout(()=>{
				hyperChat(sendTxt).then(res => {
					setSendTxt(null)
					list[list.length-1]['responder_content'] = res
					setPageList([...list])
				})
			},500)
        }
    }, [sendTxt])
    useEffect(()=>{
        handleScrollContainer()
    },[pageList])
    var isReload = false
    useEffect(() => {
        if (!isReload&&clearContent) {
            isReload = true
            if(dictionary_meta) getHisList()
            setTimeout(()=>{
                isReload = false
                setClearContent(false)
            },1000)
        }
    }, [clearContent])
    useEffect(() => {
        if (!isReload) {
            isReload = true
            if(dictionary_meta) getHisList()
            setTimeout(() => {
                isReload = false
            }, 1000)
        }
    }, [homePageIndex])
    const handleScrollContainer = ()=>{
		chatEndRef.current?.scrollIntoView({ behavior: viewType })
		// const scrollContainer = document.getElementById('scrollable-element');
		// scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
    //获取历史记录
    const getHisList = () => {
        getHistoryMessages({context_id: dictionary_meta?.context_id}).then(res => {
            if (res.code === 200) {
				setViewType('instant')
                setPageList(res.data)
            }
        })
    }
	const chatEndRef = useRef(null);

    return (
        <div className='bg'>
            <div className={`bgWrap ${themeVlue==='default'?'':'drak'}`} id={'scrollable-element'}>
                {
                    pageList && pageList.length > 0 ?
                        pageList.map(res => {
                            return (
                                <div>
                                    {res?.user_content?
                                        <div className="question">
                                            <Row>
                                                <Col span={1}> </Col>
                                                <Col span={19} className="questionInfo" style={sizeStyle}>
                                                    <DictionaryQuestion question={res.user_content}/>
                                                </Col>
                                                <Col className='headPortrait' span={4}>
                                                    <Image preview={false} src={userInfo?.avatar} width={30}/>
                                                </Col>
                                            </Row>
                                        </div>:''}
                                    {
                                        res?.responder_content&&res?.responder_content.length>0?
                                            <div className={"answer"}>
                                                <Row>
                                                    <Col span={4} className="answerHeadPortrait">
                                                        <Image preview={false}
															   src={dictionary_meta.responder_avatar?dictionary_meta.responder_avatar:require('../../../assets/comm/ai-chat-logo.png')}
															   width={30} height={30} style={{borderRadius:'50%'}}/>
                                                    </Col>
                                                    <Col span={19}>
                                                        <DictionaryAnswer answer={res.responder_content}/>
                                                    </Col>
                                                    <Col span={1}> </Col>
                                                </Row>
                                                <CreateChatApp addParam={res} originalScenario={'dictionary'} setHomePageIndex={setHomePageIndex} />
                                            </div>:''
                                    }

                                </div>
                            )
                        })
                        : ''
                }

				<div ref={chatEndRef} />

            </div>
        </div>
    )
};
export default App;
